import { THEME_IMAGES, IMAGE_PREFIX } from 'UIShared';

export function getResource(resource: keyof THEME_IMAGES) {
  return `var(${IMAGE_PREFIX}${resource})`;
}
